import { Injectable } from "@angular/core";
import { Select, Store } from "@ngxs/store";
import { USECASE } from "../../model/usecase.model";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  setBiometrics,
  setBioSealFormat,
  setContentDefault,
  setDefaultBioseal,
} from "../../store/actions/bioseal.action";
import { setDefaultFace } from "../../store/actions/face.action";
import {
  setContentType,
  setDefaultGlobal,
} from "../../store/actions/global.action";
import { BioSealState } from "../../store/state/bioseal.state";

import { GlobalState } from "../../store/state/global.state";
import { Sandbox } from "../sandbox";
import { setDefaultId } from "../../store/actions/id.action";

@Injectable()
export class ConfigurationSandbox extends Sandbox {
  @Select(BioSealState.getBioSealFormat) format: Observable<string>;
  @Select(BioSealState.getBiometricsType) biometrics: Observable<string>;
  @Select(GlobalState.getUseCase) useCase: Observable<USECASE>

  constructor(private store: Store) {
    super(store);
  }
  startState() {
    this.store.dispatch(new setDefaultFace());

    this.store.dispatch(new setDefaultGlobal());

    this.store.dispatch(new setDefaultBioseal());

    this.store.dispatch(new setDefaultId());
  }

  setBioSealFormat(format) {
    this.useCase.subscribe(
      (useCase) => {
        if (useCase === USECASE.ACCREDITATION) {
          this.store.dispatch(new setBioSealFormat(format));
        }
        else {
          this.store.dispatch(new setBioSealFormat(format.target.value));
        }
      }
    );
  }
  setBiometricsType(value) {
    this.store.dispatch(new setBiometrics(value.target.value));
  }
  setContentType(content) {
    this.store.dispatch(new setContentType(content));
  }
  setDefaultContent() {
    this.store.dispatch(new setContentDefault());
  }

  isFormatSquare() {
    return this.format.pipe(
      map((res) => {
        return res === "BigSquare";
      })
    );
  }
  isFormatRectangle() {
    return this.format.pipe(
      map((res) => {
        return res === "BigRectangle";
      })
    );
  }
  isFacial() {
    return this.biometrics.pipe(
      map((res) => {
        return res === "facial";
      })
    );
  }
  isUpload() {
    return this.biometrics.pipe(
      map((res) => {
        return res === "upload";
      })
    );
  }
  isBoth() {
    return this.biometrics.pipe(
      map((res) => {
        return res === "both";
      })
    );
  }
  isBiometrics(): Observable<boolean> {
    return this.contentType.pipe(
      map((res) => {
        return res;
      })
    );
  }
}
